import { DownloadViewModal } from '@/components/modals/DownloadViewModal'
import { useToggle } from '@/hooks/useToggle'
import { Button } from 'nsw-ds-react'
import Icon from '../Icon'

export const DownloadSyllabusOrCourseButton = ({
	syllabusCodename,
	syllabusTitle,
	isPreviewMode,
}: {
	syllabusCodename: string
	syllabusTitle: string
	isPreviewMode: boolean
}) => {
	const [showModal, toggleModal] = useToggle()

	return (
		<>
			<Button
				className="flex justify-center"
				style="white"
				css={{
					'& > *': {
						flexShrink: 0,
					},
				}}
				onClick={toggleModal}
			>
				<span className="mr-2">Download</span>
				<Icon icon="bxs:download" />
			</Button>
			{showModal && (
				<DownloadViewModal
					modalStatus={showModal}
					onCancel={toggleModal}
					isCECHideContentPicker
					titleOverride={syllabusTitle}
					isPreviewMode={isPreviewMode}
					syllabuses={[]}
					selectedSyllabuses={[syllabusCodename]}
					selectedElements={[]}
					selectedStages={[]}
					keyLearningAreas={[]}
					stages={[]}
					disabledLearningAreas={[]}
					disabledStages={[]}
				/>
			)}
		</>
	)
}
